import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "custom-container" }
const _hoisted_2 = { class: "h4 text-primary" }
const _hoisted_3 = { class: "row pt-2" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h6" }, " Signed By ")
], -1)
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "font-weight-bold mr-1" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "card mb-3 shadow-sm"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "card-body border-0 rounded py-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h6" }, "No Data Available")
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 mb-3 mt-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h6" }, " Not Signed By ")
], -1)
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "font-weight-bold mr-1" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 3,
  class: "card mb-3 shadow-sm"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "card-body border-0 rounded py-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h6" }, "No Data Available")
], -1)
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_profile_image = _resolveComponent("profile-image")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_card_row = _resolveComponent("card-row")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { crumbs: _ctx.crumbs }, null, 8, ["crumbs"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, null, {
        title: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.pageTitle), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Filter, {
        class: "mb-4",
        ref: "filter",
        filtersProp: _ctx.filterData,
        onClearFilter: _ctx.clearFilter,
        onApplyFilter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filter($event)))
      }, null, 8, ["filtersProp", "onClearFilter"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (_ctx.employees.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (item) => {
                  return (_openBlock(), _createBlock(_component_card_row, {
                    key: item.employeeId
                  }, {
                    avatar: _withCtx(() => [
                      _createVNode(_component_profile_image, {
                        "employee-id": item.id,
                        image: _ctx.hasProfileImage(item),
                        mode: "list",
                        gender: item.gender
                      }, null, 8, ["employee-id", "image", "gender"])
                    ]),
                    details: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 1),
                        _createElementVNode("div", {
                          class: _normalizeClass(`badge badge-pill ${
                    item.isSigned == true
                      ? 'badge-primary-light'
                      : 'badge-danger-light'
                  } `)
                        }, [
                          _createTextVNode(_toDisplayString(item.isSigned == true ? "Signed" : "Not Signed") + " ", 1),
                          _createVNode(_component_font_awesome_icon, {
                            class: "ml-1",
                            icon: "check-circle"
                          })
                        ], 2)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(`${item.isSigned == true ? 'text-muted' : ''}`)
                      }, " Work Email: " + _toDisplayString(item.workEmail), 3)
                    ]),
                    actions: _withCtx(() => [
                      (item.isSigned == false)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "btn btn-sm btn-warning px-2",
                            onClick: _withModifiers(($event: any) => (_ctx.sendDocumentEmail(item.workEmail)), ["prevent"])
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              class: "mr-1",
                              icon: "history"
                            }),
                            _createTextVNode(" Send Reminder ")
                          ], 8, _hoisted_8))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (_ctx.totalCount > 15)
                  ? (_openBlock(), _createBlock(_component_PaginationComponent, {
                      key: 0,
                      "page-count": _ctx.totalPages,
                      perPage: _ctx.perPage,
                      "click-handler": _ctx.goToPage
                    }, null, 8, ["page-count", "perPage", "click-handler"]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11)),
          _hoisted_12,
          (_ctx.notSingnedEmployees.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notSingnedEmployees, (item) => {
                  return (_openBlock(), _createBlock(_component_card_row, {
                    key: item.employeeId
                  }, {
                    avatar: _withCtx(() => [
                      _createVNode(_component_profile_image, {
                        "employee-id": item.id,
                        image: _ctx.hasProfileImage(item),
                        mode: "list",
                        gender: item.gender
                      }, null, 8, ["employee-id", "image", "gender"])
                    ]),
                    details: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 1),
                        _createElementVNode("div", {
                          class: _normalizeClass(`badge badge-pill ${
                    item.isSigned == true
                      ? 'badge-primary-light'
                      : 'badge-danger-light'
                  } `)
                        }, [
                          _createTextVNode(_toDisplayString(item.isSigned == true ? "Signed" : "Not Signed") + " ", 1),
                          _createVNode(_component_font_awesome_icon, {
                            class: "ml-1",
                            icon: "check-circle"
                          })
                        ], 2)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(`${item.isSigned == true ? 'text-muted' : ''}`)
                      }, " Work Email: " + _toDisplayString(item.workEmail), 3)
                    ]),
                    actions: _withCtx(() => [
                      (item.isSigned == false)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "btn btn-sm btn-warning px-2",
                            onClick: _withModifiers(($event: any) => (_ctx.sendDocumentEmail(item.workEmail)), ["prevent"])
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              class: "mr-1",
                              icon: "history"
                            }),
                            _createTextVNode(" Send Reminder ")
                          ], 8, _hoisted_15))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (_ctx.notSingnedtotalCount > 15)
                  ? (_openBlock(), _createBlock(_component_PaginationComponent, {
                      key: 0,
                      "page-count": _ctx.notSignedtotalPages,
                      perPage: _ctx.notSingnedPerPage,
                      "click-handler": _ctx.goToNotSignedPage
                    }, null, 8, ["page-count", "perPage", "click-handler"]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
        ])
      ])
    ]),
    _createVNode(_component_ConfirmationModal, { ref: "confirmDialogue" }, null, 512)
  ], 64))
}